module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_3"
    }
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "b2"
    }
  }), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_002#a2"
    }
  }, [_vm._v("Introduction"), _c('span', {
    staticClass: "normal-caps2"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I feel it necessary to, right from the start, give you a disclaimer regarding this book. While I am in fact a Professional Organizer and I do make my living organizing other people’s homes, teaching college workshops on organization and creating weekly YouTube videos and blog posts offering organizing tips… "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("I am a crazy, unorganized, giant disaster on the inside. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("I AM NOT")]), _vm._v(" a naturally organized person. In fact, the majority of my life has been spent living as a complete and utter super slob. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("Want some examples of my extreme slobiness? Brace yourself. In my early twenties, I was at the height of my all time mess making. I was working three jobs and cleaning my apartment wasn’t high on my priority list. My fridge got so bad that I decided to try and mask the putrid smell with Pine-Sol. Note: DO NOT POUR PINE-SOL IN YOUR FRIDGE AND LEAVE IT THERE. The only thing this did was make everything smell, and taste like artificial pine trees….for months. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I also threw out an obnoxious amount of pots and pans because weeks of caked on grime seemed so daunting that it was easier to just buy new ones. I eventually switched over entirely to paper plates and plastic cutlery too. Did I mention the piles of dirty clothes that covered almost every square inch of my floor? I had literal paths carved into them so I could walk from one room into the next. I’m making you feel like Martha Stewart right about now, aren’t I? "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("Was I lazy? Of course I was. Am I still lazy? Absolutely! The only difference is that now I have discovered easy and inexpensive tips, tricks, and solutions that allow me to have a clean, organized, and functional home with minimal effort to maintain it. I have gone out of my way to find and create solutions that make my home seem almost self-cleaning; I have way more important things to do than spend my time cleaning up all day long, like binge watching Netflix! My point is, if I can have a clean and clutter-free home, you can certainly have one, too. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("I have read dozens of amazing books on home organization. I would wager a bet that I have pretty much read every book ever written on the subject, as organizing has become my most favorite hobby (obsession). I am constantly on the hunt for new and unique ways to make my life easier (a.k.a allow me to be even lazier). I have organized my own home, clients’ homes, and spent the past seven years dedicating myself to learning as much as I possibly can about how best to have a clean, clutter-free and functional home with the least amount of effort to maintain it. I wanted to put together this book and share the very best advice I have learned for real life organizing for real people with kids and pets—and, well, just a whole lot of stuff. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('span', [_c('img', {
    staticClass: "frame4",
    attrs: {
      "alt": "RealLifeOrg_FINAL-11.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-11_fmt.png"
    }
  })])]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("So here is how my organizing journey began. After we had our first daughter, Isabelle (Izzy), I was adamant that I would stay home with her full time, so I started a daycare from my house. When I say I “started a daycare,” what I mean is I first tried everything I could think of to earn money while being a stay at home parent, and when all of those ideas failed miserably, the idea of babysitting other children seemed like my only viable option. One morning I randomly placed an advertisement offering childcare services online and handed out a few flyers in our neighbourhood (no thought or organization was put into this venture). In just a few short days, after dozens of calls from neighbourhood parents, I was running a home daycare just like that. At one point, I was watching nine children…nine! My life and my home were filled with brightly colored toys, loud screaming children, and absolute chaos. This last minute career option turned out to be more amazing than I could ever have hoped for. I was able to be home with my children and they were able to have wonderful friends each and everyday to play with. Being a daycare provider helped me to become the best parent I could be. I spent my days singing songs, doing crafts, and playing games with my children (there was also a lot of snot…and poop)."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Running a daycare from our tiny home came at a price, though. Our home had little storage and was bursting with toys, games, craft supplies, and endless amounts of baby stuff. Why do such tiny babies need soooo much stuff? "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369db6d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_007.vue
// module id = 78
// module chunks = 0